import api from "./api";
import { IOrder, ITicket } from "./types/data";

export const getOptions = () => {
  return api.get(`/options`);
};
export const getOptionsByActivity = (activityId: number = 1) => {
  return api.get(`/options/activity/${activityId}`);
};
export const getSingleActivity = (activityId: number = 1) => {
  return api.get(`/activity/${activityId}`);
};
export const postOrder = (data: IOrder) => {
  return api.post(`/orders`, data);
};
export const postPayment = (data: ITicket) => {
  return api.post(`/tickets`, data);
};
export const checkReferer = (data: { code: string }) => {
  return api.post(`/referers/check`, data);
};

export const getCategories = () => {
  return api.get(`/category`);
};
export const getIntervention = (page: number = 1, limit: number = 10) => {
  return api.get(`/intervention?limit=${limit}&page=${page}`);
};
export const getTribunes = (page: number = 1, limit: number = 10) => {
  return api.get(`/tribune?limit=${limit}&page=${page}`);
};
export const getBook = (page: number = 1, limit: number = 10) => {
  return api.get(`/book?limit=${limit}&page=${page}`);
};
